import React from 'react';

import { flagStyles } from '../settings';

const SvgST = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4968px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgST;
